import { render, staticRenderFns } from "./ControlLayout.vue?vue&type=template&id=220630e6&scoped=true"
import script from "./ControlLayout.vue?vue&type=script&lang=js"
export * from "./ControlLayout.vue?vue&type=script&lang=js"
import style0 from "./ControlLayout.vue?vue&type=style&index=0&id=220630e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220630e6",
  null
  
)

export default component.exports